import { combineLatest, map, Observable, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { selectAnyLoading, selectAnyDeleting, selectAnyUpdating, selectLanguaje } from '@store/selectors';
import { ComponentEnum } from '@core/enums';
import { I18nService } from '@core/services';
import { ILoadingComponent, ILoadingPresenter } from './interfaces';
import { IAbstractPresenter, ILanguageObject } from '@core/interfaces';
import { signal, SimpleChanges, WritableSignal } from '@angular/core';
import { LoadingDisplayModeEnum, LoadingDisplayModeValue } from './enums';

@Injectable({ providedIn: 'root' })
export class LoadingPresenter extends IAbstractPresenter<ILoadingComponent> implements ILoadingPresenter {
	loadingClassSignal: WritableSignal<string> = signal<string>(LoadingDisplayModeEnum.TOAST);
	isLoading$: Observable<boolean>;
	isdeleting$: Observable<boolean>;
	isUpdating$: Observable<boolean>;
	isAnyAction$: Observable<boolean>;

	translations: ILanguageObject;
	mode: LoadingDisplayModeValue = LoadingDisplayModeEnum.TOAST;

	constructor(
		private store: Store,
		private i18nService: I18nService
	) {
		super();

		this.translations = this.i18nService.getTranslations(ComponentEnum.Loading);
		this.isLoading$ = this.store.select(selectAnyLoading);
		this.isdeleting$ = this.store.select(selectAnyDeleting);
		this.isUpdating$ = this.store.select(selectAnyUpdating);
		
		this.isAnyAction$ = combineLatest([
			this.isLoading$,
			this.isdeleting$,
			this.isUpdating$,
		]).pipe(
			map(([loading, deleting, updating]) => loading || deleting || updating)
		);
	}

	override onChanges(changes: SimpleChanges): void {
		if (changes && changes['mode']) {
			this.loadingClassSignal.set(changes['mode'].currentValue);
		}
	}

	dispatchActions(): void {}

	suscribeObservers(): void {
		this.store
			.select(selectLanguaje)
			.pipe(takeUntil(this.destroy$))
			.subscribe(lang => {
				this.view.translations = this.i18nService.getTranslations(ComponentEnum.Loading, lang);
			});
	}
}
